import React, { useCallback, useMemo, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useGetSearchLabels } from 'modules/Insights/hooks/useGetSearchLabels';
import { useSupervisorInsightContext } from 'modules/Insights/Notes/SupervisorInsightContextProvider';
import { OrgAnalyticsDimensionType, OrgAnalyticsContext } from 'graphql/types';
import { useGetSupervisorAnalyticsData } from 'modules/Insights/Notes/hooks/useGetSupervisorAnalyticsData';
import MyUtilizationChart from './MyUtilizationChart';
import { transformIntoUtilizationChartData } from './utils';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%'
  }
}));

const SupervisorUtilizationChart: React.FC = () => {
  const [checked, setChecked] = useState(false);
  const labelValues = useGetSearchLabels();
  const classes = useStyles();

  const { data: rData, loading, isEmpty } = useGetSupervisorAnalyticsData(
    OrgAnalyticsDimensionType.MetricsByNoteUtilization,
    labelValues,
    OrgAnalyticsContext.Supervisor
  );

  const {
    currentPeriod,
    selectedViewOptionSupervisor
  } = useSupervisorInsightContext();
  const tData = useMemo(
    () =>
      transformIntoUtilizationChartData(
        rData?.orgAnalytics?.analyticsResult.items,
        checked,
        currentPeriod
      ),
    [checked, currentPeriod, rData]
  );

  const handleCheckBoxChange = useCallback((event) => {
    setChecked(event.target.checked);
  }, []);

  return (
    <>
      <MyUtilizationChart
        tData={tData}
        checked={checked}
        handleCheckBoxChange={handleCheckBoxChange}
        loading={loading}
        isEmpty={isEmpty}
        selectedViewOption={selectedViewOptionSupervisor}
        overrideClass={classes}
      />
    </>
  );
};

export default React.memo(SupervisorUtilizationChart);
